export default __webpack_public_path__ + "static/media/scribble-green.5da9a639.svg";